export default __webpack_public_path__ + "static/media/mobile-link.d9907649.webp";